export default __webpack_public_path__ + "2246bd885d84dc1f87ab352950018398.png";